import { cva } from 'class-variance-authority'

/**
 * The type a row is made of: a name and the sentence under it. Item.Title and Item.Description
 * are these, and so are Field.Label and Field.Note, because a justified Field is an Item whose
 * control is an input. One source so the two line up when they share a list.
 */
export const itemTitleClasses = 'text-sm font-medium text-foreground'

export const itemDescriptionVariants = cva('text-xs', {
  variants: {
    tone: {
      default: 'text-foreground-secondary',
      danger: 'text-danger-subtle',
    },
  },
  defaultVariants: { tone: 'default' },
})
